// extracted by mini-css-extract-plugin
module.exports = {"searchTabs":"SearchTabs_searchTabs__y4_Me","searchTabs__tab":"SearchTabs_searchTabs__tab__01l_k","searchTabs__tab--active":"SearchTabs_searchTabs__tab--active__b7BaP"};